<template>
    <v-chip-group
        dense
        v-model="statusSelected"
        mandatory
        @change="onGroupChange()"
        color="white"
    >
      <v-chip color="light-blue darken-1" :outlined="statusSelected !== 0">{{$t('statuses.todo')}}</v-chip>
      <v-chip color="orange darken-1" :outlined="statusSelected !== 1">{{$t('statuses.process')}}</v-chip>
      <v-chip color="green darken-1" :outlined="statusSelected !== 2">{{$t('statuses.done')}}</v-chip>
    </v-chip-group>
</template>

<script>

export default {
  name: 'BatchRunTaskStatusSelect',
  inheritAttrs: false,
  props: {
    value: {default: null},
    property_state: {default: null},
    property_state_field_name: {default: null},
    clearable: {default: false},
    returnObject: {default: false},
    itemText: {default: null},
    itemValue: {default: null},
    multiple: {default: false},
    items: {
      default: function () {
        return [
          'to-do',
          'in Bearbeitung',
          'fertig'
        ]
      }
    },
  },

  components: {},

  computed: {
    error() {
      return !!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error
    },
    error_message() {
      if (!!!!this.property_state && !!this.property_state_field_name && this.property_state[this.property_state_field_name].error)
        return this.property_state[this.property_state_field_name].error_message
      else
        return null
    },
  },

  methods: {
    onGroupChange() {
      this.$emit('input', this.statuses[this.statusSelected])
    },
  },

  async mounted() {
    this.statusSelected = this.statuses.indexOf(this.value)
  },

  data() {
    return {
      statuses: ['to-do', 'in Bearbeitung', 'fertig'],
      statusSelected: 0,
    }
  }
}
</script>

<style scoped lang="scss">
.no-spin input[type='number'] {
  -moz-appearance: textfield;
  /*width: 50px;*/
}

</style>

<i18n src="@/components/PBatchRun/locales.json">
</i18n>
